/**
 * Leaf module containing the {@link PortfolioActionUnavailableReason} enum
 * and the {@link PortfolioBulkActionAvailabilityResult} type. Lives in its own
 * file so that `BulkAnalysisReviewDialog.tsx` can import these symbols without
 * pulling in the rest of `portfolio-actions.tsx` (which would create a circular
 * dependency).
 */
import type { InvestmentProjectedListEntry, InvestmentSummary } from "@eu.mdotm.api/sphere";

export const PortfolioActionUnavailableReason = {
	ACL_EDITOR_REQUIRED: "ACL_EDITOR_REQUIRED",
	ACL_OWNER_REQUIRED: "ACL_OWNER_REQUIRED",
	USED_AS_NESTED: "USED_AS_NESTED",
	ERROR: "ERROR",
	CALCULATING: "CALCULATING",
	REVIEW: "REVIEW",
	RETRIEVING_DATA: "RETRIEVING_DATA",
	DRAFT: "DRAFT",
	CANNOT_BULK_ENHANCE: "CANNOT_BULK_ENHANCE",
	UNIVERSE_NOT_READY: "UNIVERSE_NOT_READY",
	MISSING_UNIVERSE: "MISSING_UNIVERSE",
	PROPOSAL_READY: "PROPOSAL_READY",
	CANNOT_MIX: "CANNOT_MIX",
	TOO_OLD: "TOO_OLD",
	ACCEPTED: "ACCEPTED",
	READY: "READY",
	EXECUTING: "EXECUTING",
	NOT_EXECUTING: "NOT_EXECUTING",
	PAPER_TRADING: "PAPER_TRADING",
	EXECUTION_ONLY: "EXECUTION_ONLY",
	/** Not raised by any validator: a dated export review adds the portfolios that did not exist on its date. */
	NOT_YET_INCEPTED: "NOT_YET_INCEPTED",
} as const;

export type PortfolioActionUnavailableReason =
	(typeof PortfolioActionUnavailableReason)[keyof typeof PortfolioActionUnavailableReason];

export type PortfolioBulkActionAvailabilityResult<Investment extends InvestmentSummary | InvestmentProjectedListEntry> =
	[Investment[], Record<PortfolioActionUnavailableReason, Investment[]> | null];
